import {match, Pattern} from 'ts-pattern';

import {getWorktreeName} from '@dms/config';

import {WORKTREE_HEADER} from '../constants/WORKTREE_HEADER';

/**
 * Header routing the request to a backend worktree on the local stack. Empty object when no
 * worktree is selected, so nothing is sent outside local fullstack development.
 */
export const getWorktreeHeaders = (): Record<string, string> =>
  match(getWorktreeName())
    .with(Pattern.string.minLength(1), (worktreeName) => ({[WORKTREE_HEADER]: worktreeName}))
    .otherwise(() => ({}));
